import { createContext, useState } from "react";
import clearCookies from "service/auth/logout";

import { auth, db } from "../firebase";
import { updateDoc, doc } from "firebase/firestore";
import { signOut } from "firebase/auth";

const AuthContext = createContext();

const { Provider } = AuthContext;

const AuthProvider = ({ children }) => {
  //Consider putting this in useEffect
  const jwtToken =
    process.env.NODE_ENV === "development"
      ? localStorage.getItem("token")
      : null;
  const userInfo = localStorage.getItem("userInfo");
  const expiresAt = localStorage.getItem("expiresAt");

  const [authState, setAuthState] = useState({
    jwtToken,
    expiresAt,
    userInfo: userInfo ? JSON.parse(userInfo) : {},
  });

  const setAuthInfo = ({ jwtToken, userInfo, expiresAt }) => {
    if (process.env.NODE_ENV === "development") {
      localStorage.setItem("token", jwtToken);
    }
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
    localStorage.setItem("expiresAt", expiresAt);

    setAuthState({
      jwtToken,
      userInfo,
      expiresAt,
    });
  };

  const logout = async () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("expiresAt");

    try {
      const usersRef = doc(db, "users", authState.userInfo.firebaseUid);
      const data = { isOnline: false };

      updateDoc(usersRef, data)
        .then((usersRef) => {
          console.log("Field has been added to an existing document");
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (err) {
      console.log("Error while creating user on firebase:" + err);
    }
    clearCookies(authState.userInfo?.cifNumber).finally(() => setAuthState({}));
    await signOut(auth);
  };

  const isAuthenticated = () => {
    if (!authState.userInfo || !authState.expiresAt) {
      return false;
    }
    if (Date.now() >= authState.expiresAt) {
      return false;
    } else {
      return true;
    }
  };

  const changeAccountStatus = (accountStatus) => {
    setAuthState((prevState) => {
      return {
        ...prevState,
        userInfo: {
          ...prevState.userInfo,
          accountStatus,
        },
      };
    });
    localStorage.setItem(
      "userInfo",
      JSON.stringify({
        ...authState.userInfo,
        accountStatus,
      })
    );
  };

  const isCoordinator = () =>
    authState?.userInfo?.userType === "CUSTOMERSUCCESSMANAGER";
  const isParent = () => authState.userInfo?.userType === "PARENT";
  const isStudent = () => authState?.userInfo?.userType === "STUDENT";
  const isTutor = () => authState.userInfo.userType === "TEACHER";
  const isAdmin = () => authState.userInfo.userType === "ADMINISTRATOR";
  const isSupport = () => authState.userInfo.userType === "TECHSUPPORT";
  const isQCS = () => authState.userInfo.userType === "QUALITYCONTROL";

  return (
    <Provider
      value={{
        authState,
        setAuthState: (authInfo) => setAuthInfo(authInfo),
        logout,
        isAuthenticated,
        isCoordinator,
        isParent,
        isTutor,
        isStudent,
        isAdmin,
        isSupport,
        isQCS,
        changeAccountStatus,
      }}
    >
      {children}
    </Provider>
  );
};

export { AuthContext, AuthProvider };
